export const localStorageMiddleware = storeAPI => next => action => {
  const result = next(action)

  // On any cart mutation, write to localStorage
  if (action.type.startsWith('cart/')) {
    const { items } = storeAPI.getState().cart
    localStorage.setItem('cart', JSON.stringify(items))
  }

  return result
}
